import script from "./ReportsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsView.vue?vue&type=script&setup=true&lang=js"

import "./ReportsView.vue?vue&type=style&index=0&id=0b775a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b775a86"]])

export default __exports__